import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const studyTreatmentManagementServices = {
  //Treatment Column
  addNewStudyTreatmentColumn,
  updateStudyTreatmentColumnData,
  deleteStudyTreatmentColumnData,
  softDeleteRestoreStudyTreatmentColumn,
  getStudyTreatmentColumnData,
  
  //Treatment Row
  addNewStudyTreatmentRow,
  updateStudyTreatmentRowData,
  deleteStudyTreatmentRowData,
  softDeleteRestoreStudyTreatmentRow,
  updateStudyTreatmentRowOrderData,
  getStudyTreatmentRowData,
  getHeighestVersionTreatmentRowHistory,
  getStudyTreatmentAuditTrials
};

// Get Study Treatment Column
async function getStudyTreatmentColumnData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyTreatmentColumnData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyTreatmentColumnData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Treatment Column
async function addNewStudyTreatmentColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyTreatmentColumn`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Treatment Column
async function updateStudyTreatmentColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyTreatmentColumnData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Treatment Column
async function softDeleteRestoreStudyTreatmentColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyTreatmentColumn`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Treatment Column
async function deleteStudyTreatmentColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyTreatmentColumnData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Treatment Row
async function getStudyTreatmentRowData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyTreatmentRow/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyTreatmentRow/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Treatment Row
async function addNewStudyTreatmentRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyTreatmentRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Treatment Row
async function updateStudyTreatmentRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyTreatmentRowData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Treatment Row
async function softDeleteRestoreStudyTreatmentRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyTreatmentRow`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Study Treatment Order
async function updateStudyTreatmentRowOrderData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyTreatmentRowOrderData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Treatment Row
async function deleteStudyTreatmentRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyTreatmentRowData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Treatment Row Heighest version
async function getHeighestVersionTreatmentRowHistory(studyId, treatmentId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getHeighestVersionTreatmentRowHistory/${studyId}/${treatmentId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Study Treatment Row Audit Trial
async function getStudyTreatmentAuditTrials(studyId, treatmentId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyTreatmentAuditTrials/${studyId}/${treatmentId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}